<template>
  <div>
    <h1>Test Email</h1>
    <p>Click the button below to send a test email.</p>
    <button @click="sendTestEmail">Send Test Email</button>
  </div>
</template>
<script>
// import { Resend } from "resend";

export default {
  methods: {
    sendTestEmail() {
      const resend = new Resend("re_esmM6ukc_8qZu4rZSXi8PFyakmNwpqdns");

      resend.emails.send({
        from: "onboarding@resend.dev",
        to: "nelsoncejas@gmail.com",
        subject: "Hello World",
        html: "<p>Congrats on sending your <strong>first email</strong>!</p>",
      });
    },
  },
};
</script>

<style>
</style>